module.exports = __webpack_public_path__ + "img/checkmark.81cc736f.svg";